import { fetchList } from '@/api/admin/complaints';
export default {
  data() {
    return {
      id: 0, // postId 或 commentId
      targetType: 0,
      postComplaintLoaded: false,
      postComplaintData: [],
      postComplaintPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
    }
  },
  mounted() {
    this.postComplaintLoaded = false;
  },
  methods: {
    initPostComplaint() {
      if (this.postComplaintLoaded) {
        return;
      }

      this.getPostComplaintList();
    },
    getPostComplaintList() {
      let params = {
        current: this.postComplaintPage.currentPage,
        size: this.postComplaintPage.pageSize,
        targetId: this.id,
        targetType: this.targetType,
      }
      fetchList(params).then(response => {
        if (response.data.data != null) {
          this.postComplaintData = response.data.data.records.map(item => {
            item.handleResult = this.formateHandleResult(item.handleResult);
            item.targetType = this.formateTargetType(item.targetType);
            item.complainedByRealname = item.complainedByMemberType === 1
              ? item.complainedByRelatedPersonalRealname
              : item.complainedByRealname;
            item.complainedToRealname = item.complainedToMemberType === 1
              ? item.complainedToRelatedPersonalRealname
              : item.complainedToRealname;
            return item;
          });
          this.postComplaintPage.total = response.data.data.total;
        } else  {
          this.postComplaintData = []
          this.postComplaintPage.total = 0;
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取举报列表失败',
          type: 'error'
        });
      });
      this.postComplaintLoaded = true;
    },
    postComplaintCurrentChange(val) {
      this.postComplaintPage.currentPage = val;
      this.getPostComplaintList();
    },
    postComplaintSizeChange(val) {
      this.postComplaintPage.pageSize = val;
      this.getPostComplaintList();
    },
    formateHandleResult(val) {
      if ( val === 0 ) return '未处理'
      if ( val === 1 ) return '已忽略'
      if ( val === 2 || val === 3 ) return '已下架'
    },
    formateTargetType(val) {
      if ( val === 0 ) return '内容'
      if ( val === 1 ) return '评论'
    },
  }
}
